import { HTMLAttributes, ReactElement, useEffect, useState } from 'react';

export const useDynamicSvgIcon = (svgName: string, role?: HTMLAttributes<SVGElement>['role']) => {
  const [svgElement, setSvgElement] = useState<ReactElement>();

  useEffect(() => {
    if (svgName) {
      try {
        const getSvgComponent = async () => {
          const svg = await import(`@gn-audio/icons/src/icons/${svgName}.svg`);
          setSvgElement(svg.default({ role }));
        };
        getSvgComponent();
      } catch (error) {
        console.error('Failed to import the SVG', error);
      }
    }
  }, [svgName, role]);

  return { svgElement };
};
